import React, { useState } from 'react';
import { PRODUCTS } from '../data/constants';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';
import { scrollToSection } from '../utils/scrollTo';
import ProductModal from './ProductModal';
import type { Product } from '../types';

const Gallery: React.FC = () => {
  const { setRef, isVisible } = useIntersectionObserver();
  const [active, setActive] = useState<Product | null>(null);

  return (
    <section id="gallery" ref={setRef('gallery')} className="gallery-section">
      <div className="gallery-inner">
        <div className={`gallery-header sf ${isVisible('gallery') ? 'vis' : ''}`}>
          <div>
            <div className="eyebrow-dark">What we do</div>
            <h2 className="section-h2" style={{ marginBottom: 0 }}>Our Gallery</h2>
          </div>
          <button className="btn-outline-navy" onClick={() => scrollToSection('contact')}>All Products →</button>
        </div>

        <div className="gallery-grid">
          {PRODUCTS.slice(0, 13).map((p, i) => (
            <div
              key={p.title}
              className={`gallery-item sf ${isVisible('gallery') ? 'vis' : ''}`}
              style={{ transitionDelay: `${i * 0.07}s` }}
              onClick={() => setActive(p)}
            >
              <img src={p.img} alt={p.title} />
              <div className="gallery-item-overlay">
                <div className="gallery-item-tag">{p.tag}</div>
                <div className="gallery-item-title">{p.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {active && (
        <ProductModal
          product={active}
          onClose={() => setActive(null)}
          onQuote={() => { setActive(null); scrollToSection('contact'); }}
        />
      )}
    </section>
  );
};
export default Gallery;
